import employee from './employee'

export default employee
